import {
    handleDeleteIconMouseEnter,
    handleEnabledIconMouseEnter,
    handleEnabledIconMouseLeave,
    uiStyles
} from 'lib/uiUtils';
import {
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    FolderOpen as FolderOpenIcon
} from '@material-ui/icons';
import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField, Tooltip } from '@material-ui/core';

/* Campo padrão para seleção e remoção de arquivos */
const FileField = ({
    accept,
    disabled,
    inputRef,
    label,
    onChange,
    onRemove,
    removeTooltip,
    selectTooltip,
    value
}) => {
    const hasFile = !!value;
    const uploadDisabled = disabled || hasFile;
    const removeDisabled = disabled || !hasFile;

    return (
        <TextField
            label={label}
            variant="outlined"
            value={value || ''}
            disabled
            fullWidth
            InputProps={{
                endAdornment: (
                    <InputAdornment
                        position="end"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        }}
                    >
                        <Tooltip title={selectTooltip}>
                            <label
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    lineHeight: 0,
                                    cursor: uploadDisabled ? 'default' : 'pointer'
                                }}
                            >
                                <FolderOpenIcon
                                    onMouseEnter={event => (
                                        handleEnabledIconMouseEnter(event, uploadDisabled)
                                    )}
                                    onMouseLeave={event => (
                                        handleEnabledIconMouseLeave(event, uploadDisabled)
                                    )}
                                    style={{
                                        ...uiStyles.actionIcon,
                                        color: uploadDisabled
                                            ? uiStyles.disabledActionIcon.color
                                            : uiStyles.actionIcon.color,
                                        cursor: uploadDisabled ? 'default' : 'pointer'
                                    }}
                                />

                                <input
                                    ref={inputRef}
                                    type="file"
                                    accept={accept}
                                    style={{ display: 'none' }}
                                    onChange={onChange}
                                    disabled={uploadDisabled}
                                />
                            </label>
                        </Tooltip>

                        <Tooltip title={removeTooltip}>
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    lineHeight: 0
                                }}
                            >
                                <DeleteForeverOutlinedIcon
                                    onClick={removeDisabled ? undefined : onRemove}
                                    onMouseEnter={event => (
                                        handleEnabledIconMouseEnter(event, removeDisabled, handleDeleteIconMouseEnter)
                                    )}
                                    onMouseLeave={event => (
                                        handleEnabledIconMouseLeave(event, removeDisabled)
                                    )}
                                    style={{
                                        ...uiStyles.actionIcon,
                                        color: removeDisabled
                                            ? uiStyles.disabledActionIcon.color
                                            : uiStyles.actionIcon.color,
                                        cursor: removeDisabled ? 'default' : 'pointer',
                                        pointerEvents: removeDisabled ? 'none' : 'auto'
                                    }}
                                />
                            </span>
                        </Tooltip>
                    </InputAdornment>
                )
            }}
        />
    );
};

FileField.propTypes = {
    accept: PropTypes.string,
    disabled: PropTypes.bool,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.any
        })
    ]),
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    removeTooltip: PropTypes.string,
    selectTooltip: PropTypes.string,
    value: PropTypes.string
};

FileField.defaultProps = {
    accept: '*/*',
    disabled: false,
    inputRef: undefined,
    removeTooltip: 'Remover',
    selectTooltip: 'Buscar arquivo',
    value: ''
};

export default FileField;